export default __webpack_public_path__ + "static/media/mood_laugh.0ea0b8a6.svg";